import { render, staticRenderFns } from "./video-daily-data-list.vue?vue&type=template&id=cbf96496"
import script from "./video-daily-data-list.vue?vue&type=script&lang=js"
export * from "./video-daily-data-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports